"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  CommonSetLocation: true,
  CommonSetLocationForm: true,
  CommonSetLocationReducers: true
};
exports.CommonSetLocationReducers = exports.CommonSetLocationForm = exports.CommonSetLocation = void 0;
var _commonSetLocationWrapper = _interopRequireDefault(require("./components/common-set-location-wrapper"));
exports.CommonSetLocation = _commonSetLocationWrapper["default"];
var _commonSetLocation = _interopRequireDefault(require("./components/common-set-location"));
exports.CommonSetLocationForm = _commonSetLocation["default"];
var _store = require("./store");
exports.CommonSetLocationReducers = _store.CommonSetLocationReducers;
var _commonSetLocation2 = require("./components/common-set-location.propTypes");
Object.keys(_commonSetLocation2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _commonSetLocation2[key]) return;
  exports[key] = _commonSetLocation2[key];
});
var _utils = require("./utils");
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  exports[key] = _utils[key];
});